import { CreateAppFromCopilotForDevops } from "../../../Components/Integrations/CreateAppForm";
import { AliceGPTContextProvider } from "../../../Context/AliceGPT/AliceGPTContext";

function CreateApp() {
    return (
        <AliceGPTContextProvider>
            <CreateAppFromCopilotForDevops />
        </AliceGPTContextProvider>
    )
}

export default CreateApp;